import { pipe, toPairs, any, both, propEq, pathEq, not, compose, filter } from 'ramda'

export const canLinkExternal = externalType =>
  pipe(
    filter(propEq('ExternalType', externalType)),
    any(compose(not, pathEq(['FeatureFlags', 'LinkingToExternalResource'], 'NotAllowed'))),
  )
